import { Avatar as MUIAvatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { forwardRef } from 'react';

import { IAvatarProps } from './Avatar.types';

const Avatar = forwardRef<HTMLDivElement, IAvatarProps>(
  ({ color = 'default', children, sx, ...other }, ref) => {
    const theme = useTheme();

    if (color === 'default') {
      return (
        <MUIAvatar ref={ref} sx={sx} {...other}>
          {children}
        </MUIAvatar>
      );
    }

    return (
      <MUIAvatar
        ref={ref}
        sx={{
          fontSize: theme.typography.subtitle1,
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette[color].contrastText,
          backgroundColor: theme.palette[color].main,
          ...sx,
        }}
        {...other}
      >
        {children}
      </MUIAvatar>
    );
  }
);

export { Avatar };
